import { commonShortNouns } from "./common-short-fields";
export const centersCenterZh = {
  title: "服务入口与中心状态",
  subtitle: "按服务入口注册表查看服务入口、平台中心与业务入口的当前连通状态。",
  infoMessage: "平台后台与考试后台已拆层。具体公开入口由服务入口注册表派生；平台后台只承载平台层页面，考试业务后台承载考试业务管理。",
  summaryDirectProbes: "后端直探",
  summaryRestricted: "受限入口",
  tableTitle: "服务入口与中心清单",
  tableSubtitle: "服务入口、平台中心、业务入口与兼容网关统一从注册表投影中盘点。",
  groupedTitle: "按职责分组浏览",
  groupedSubtitle: "先按平台壳、中心、能力、基础设施和业务入口分段浏览，再进入具体明细。",
  drawerTitle: "{name} · 详情",
  detailBasicTitle: "基础状态",
  detailRuntimeTitle: "接入与依赖",
  detailProbeTitle: "探活细节",
  detailAccessRequirement: "访问要求",
  openConsole: "打开控制台",
  footerHint: "当前平台后台会优先复用考试后台的通用前端基座，但不复用题库、试卷、考试等业务页面本身。",
  notices: {
    signalSemantics: "本页状态优先读取后台聚合探活结果；没有独立探活的条目会明确标记为共享健康、依赖接入或目录项。",
    backendProbe: "当前探活来自后台 `/api/identity/platform-overview` 聚合，最近检查时间：{value}",
  },
  cards: {
    coverageTitle: "状态信号覆盖",
    accessTitle: "访问覆盖",
    catalogTitle: "目录构成",
    attentionTitle: "异常队列",
    accessReasonTitle: "受限原因",
    attentionPreviewTitle: "当前关注项",
    attentionPreviewDescription: "优先列出离线、降级、未完成接入、受限和仅目录项，方便先定位处理顺序。",
  },
  metrics: {
    openableEntries: "可直接打开",
    unstableEntries: "异常状态入口",
    unintegratedEntries: "未完成接入",
    restrictedEntries: "受限入口",
    directoryOnlyEntries: "仅目录项",
    restrictedReasonNone: "当前权限",
    none: "无",
    andMore: "+{count} 个",
  },
  signal: {
    directHealth: "后端直探",
    sharedHealth: "共享健康",
    providerDependency: "依赖接入",
    directoryOnly: "目录项",
  },
  access: {
    available: "可访问",
    restricted: "受限",
    externalSurface: "外部入口，不受平台后台菜单权限限制",
    platformManagement: "需要平台管理权限",
    platformDashboard: "需要平台后台访问权限",
    identity: "需要统一身份中心权限",
    assets: "需要资产中心权限",
    environment: "需要环境中心权限",
    execution: "需要执行中心权限",
    intelligence: "需要智能中心权限",
    capabilityGraph: "需要能力图谱权限",
    tacticsTechniques: "需要技战法知识库权限",
    vulnerabilityLibrary: "需要漏洞信息库权限",
    businessReference: "需要业务引用中心权限",
    trafficLibrary: "需要流量库权限",
  },
  filters: {
    scope: {
      all: "全部范围",
      platform: "仅平台",
      business: "仅业务",
      restricted: "仅受限",
    },
    signal: {
      all: "全部信号",
    },
    access: {
      all: "全部访问",
      available: "可访问",
      restricted: "受限",
    },
  },
  views: {
    list: "完整清单",
    grouped: "分组浏览",
  },
  groups: {
    platformEntry: {
      title: "平台入口",
      description: "平台壳层与统一入口，承担后台、门户和账号入口职责。",
    },
    platformCenter: {
      title: "平台中心",
      description: "具备独立治理职责的核心中心页面，直接承接平台控制面操作。",
    },
    platformCapability: {
      title: "平台能力",
      description: "复用平台基座承载的能力模块，更偏向专题治理和分析工作面。",
    },
    platformInfrastructure: {
      title: "平台基础设施",
      description: "对外基础服务与兼容面，适合确认底座连通性和运行状态。",
    },
    businessEntry: {
      title: "业务入口",
      description: "业务服务与业务控制台入口，重点看注册表入口、可达性和依赖状态。",
    },
  },
  table: {
    name: "服务 / 入口",
    category: "分类",
    domain: "入口域名",
    entryAddress: "入口地址",
    status: commonShortNouns.status,
    latency: "延迟",
    signal: "状态来源",
    access: "访问",
    mode: "模式",
    phase: "阶段",
    dependencies: "依赖",
    note: "说明",
    actions: "操作",
  },
} as const;
